/* eslint-disable @typescript-eslint/no-explicit-any */

import { filter, includes, map, toString } from 'es-toolkit/compat';
import { safeEnumCompare } from '@tock/coretypes';
import protos from 'utils/protos';

const { TableShape } = protos;

export const DEFAULT_VISUAL_SIZE = 2;
export const MAX_VISUAL_SIZE = 4;

export const GRID_SIZE = 24;

export const serviceGutterX = 1024 - 672;
export const serviceGutterY = 768 - 564;

export const getIPadDimensions = (maxX: number, maxY: number) => {
  return {
    maxX: Math.floor((maxX - serviceGutterX) / GRID_SIZE),
    maxY: Math.floor((maxY - serviceGutterY) / GRID_SIZE),
  };
};

export const AerialTableRotationOptions = map(['0', '90', '180', '270'], (rotation: string) => {
  return {
    key: rotation,
    label: rotation + '°',
    value: rotation,
  };
});

export const AerialTableShapeOptions = filter(
  map(TableShape, (enumVal: number, shapeString: string) => {
    // DIAMOND shape doesn't fit text very nicely
    // HIGHTOP icon is currently missing
    if (includes([TableShape.DIAMOND, TableShape.HIGHTOP, TableShape.BOOTH], enumVal)) {
      return null;
    }
    return {
      key: shapeString,
      value: toString(enumVal),
    };
  })
);

export const AerialTableVisualSizeOptions = map(['2', '3', '4'], (visualSize: string) => {
  return {
    key: visualSize,
    label: visualSize,
    value: visualSize,
  };
});

export function getDefaultLocation() {
  return {
    rotation: 0,
    shape: TableShape.SQUARE,
    visualSize: DEFAULT_VISUAL_SIZE,
    xPosition: 0,
    yPosition: 0,
  };
}

export function getIconForShape(shape: any) {
  if (safeEnumCompare(shape, TableShape, TableShape.SQUARE)) {
    return 'AerialTable-square';
  } else if (safeEnumCompare(shape, TableShape, TableShape.RECT)) {
    return 'AerialTable-rectangle';
  } else if (safeEnumCompare(shape, TableShape, TableShape.CIRCLE)) {
    return 'AerialTable-circle';
  } else if (safeEnumCompare(shape, TableShape, TableShape.BOOTH)) {
    return 'AerialTable-rounded';
  } else if (safeEnumCompare(shape, TableShape, TableShape.COUNTER)) {
    return 'AerialTable-rounded';
  } else {
    return 'AerialTable-square';
  }
}

export function getNameForShape(shape: any) {
  if (safeEnumCompare(shape, TableShape, TableShape.SQUARE)) {
    return 'Square';
  } else if (safeEnumCompare(shape, TableShape, TableShape.RECT)) {
    return 'Rectangle';
  } else if (safeEnumCompare(shape, TableShape, TableShape.CIRCLE)) {
    return 'Circle';
  } else if (safeEnumCompare(shape, TableShape, TableShape.COUNTER)) {
    return 'Rounded';
  } else {
    return 'Square';
  }
}

export function getSelectedShape(currentShape: string, selectedShape: string) {
  //Frontend only solution to consolidation of booth and counter shapes
  if (
    currentShape === toString(TableShape.COUNTER) &&
    selectedShape === toString(TableShape.BOOTH)
  ) {
    return true;
  }
  return currentShape === selectedShape;
}
